module.exports = __webpack_public_path__ + "static/media/icon-banner.7a3df5fb.svg";